module.exports = __webpack_public_path__ + "media/video-poster/poster-42232205.jpg";